import { checkRunDetails, checkRunQuantities, type IrrigationRecordRunV2 } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'
import { localDate } from '../lib/time.ts'

/** M16-L1 (docs/M16.md rule 2): the projection of irrigation.record_run@2, a field FACT. The run shows in the list at once, pending, on the club's own
 *  day, with what was typed, its cycles and its soak included, until the server's row replaces it; one the twins of the server's value rules would refuse
 *  (the quantities, the cycle rule) is not projected, and the server's refusal then tells the person. A record, never an instruction. The id is the
 *  device's own (newId), so a retry duplicates nothing. @1's projection stays in projectors.ts; the office's acts of the part (a correction, the
 *  events on a fault, the site's constraints) have none. Registered in projectors.ts. */
export const irrigationRecordRun2: Projector = async (cmd, db) => {
  const p = cmd.payload as IrrigationRecordRunV2
  if (checkRunQuantities({ durationMin: p.duration_min ?? null, depthMm: p.depth_mm ?? null, volumeM3: p.volume_m3 ?? null })) return []
  if (checkRunDetails({ cycles: p.cycles ?? null, soakMin: p.soak_min ?? null })) return []
  const at = p.started_at ?? cmd.occurred_at
  const tz = ((await db.site.get(cmd.site_id)) as { timezone?: string } | undefined)?.timezone ?? 'Europe/Paris'
  const row: OverlayRow = {
    key: `ops.irrigation_run:${p.run_id}`, table: 'ops.irrigation_run', id: p.run_id, command_id: cmd.command_id, op: 'insert',
    row: {
      id: p.run_id, org_id: cmd.org_id, site_id: cmd.site_id, area_id: p.area_id, station_feature_id: p.station_id ?? null, kind: p.kind, started_at: at, started_local_date: localDate(at, tz),
      duration_min: p.duration_min ?? null, depth_mm: p.depth_mm ?? null, volume_m3: p.volume_m3 ?? null, note: p.note?.trim() || null, source: 'manual', entered_at: cmd.occurred_at,
      corrects_run_id: null, correction_reason: null, superseded_by_id: null, cycles: p.cycles ?? null, soak_min: p.soak_min ?? null, actor_person_id: cmd.actor_person_id ?? null, _pending: true,
    },
  }
  return [row]
}
